export const POPUP_ANIMATION_DURATION = 300;
export const FOOTER_MAX_HEIGHT = 145;
